/** @jsx jsx */
import * as React from "react"
import { jsx } from "@emotion/core"
import { ISelectPopverOptions } from "../CustomPopover";
import { fonts } from "../../../../styles/fonts";

interface IRadioBtnGroupProps {
    options: ISelectPopverOptions[],
    handleClick: (val: string | number) => void
    inline?: boolean
    showCTA?: boolean;
    footer: any;
}

const styles = {
    radioGroupWrapper: {
        maxHeight: "210px",
        overflow: "scroll",
        padding: "0px 15px",
        minWidth: "300px"
    },
    radioButtonItemWrapper: {
        display: "flex",
        cursor: "pointer",
        margin: "12px 0",
        width: "100%",
        borderBottom: "1px solid #eaeaea",
        paddingBottom: 8
    },
    optionLabel: {
        color: "rgba(0, 0, 0, 0.87)",
        fontFamily: fonts.mediumFont,
        fontSize: 14
    },
    checkedIcon: {
        height: 21,
        marginRight: 10
    },
    unchecked: {
        opacity: 0.2,
        marginRight: 10
    },
    divider: {
        borderTop: "1px solid rgb(182, 198, 215)",
        marginTop: 5
    }
}

export const CustomRadioBtn = (props: IRadioBtnGroupProps) => {
    const { options, handleClick, showCTA, footer } = props;
    const [selectedBtnIndex, setSelectedBtnIndex] = React.useState<number>(null)

    const handleBtnClick = (val: string | number, idx: number) => {
        setSelectedBtnIndex(idx)
        handleClick && handleClick(val)
    }

    return (
        <React.Fragment>
            <div css={styles.radioGroupWrapper}>
                {
                    (options || []).map((item: ISelectPopverOptions, index: number) => <RadioBtnItem item={item} isActive={index === selectedBtnIndex} key={index} onClick={val => handleBtnClick(val, index)} />)
                }
            </div>
            {
                showCTA &&
                footer()
            }
        </React.Fragment>
    )
}

export const RadioBtnItem = (props: { item: ISelectPopverOptions, onClick: (val: string | number) => void, isActive: boolean }) => {

    return (
        <div css={styles.radioButtonItemWrapper} onClick={() => props.onClick && props.onClick(props.item.internalValue)}>
            <img css={props.isActive ? styles.checkedIcon : styles.unchecked} src={props.isActive ? "/images/pink-checkbox.png" : "/images/icons/oval-7.png"} alt="checked" />
            <span css={styles.optionLabel}>{props.item ? props.item.displayValue : ""}</span>
            {/* <hr css={styles.divider} /> */}
        </div>
    )
}